// Minimal WebAuthn browser ceremonies (base64url <-> ArrayBuffer handling).
const toB64u = (buf) =>
  btoa(String.fromCharCode(...new Uint8Array(buf)))
    .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
const fromB64u = (s) =>
  Uint8Array.from(
    atob(s.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(s.length / 4) * 4, "=")),
    (c) => c.charCodeAt(0));

export const webauthnSupported = () =>
  typeof window !== "undefined" && !!window.PublicKeyCredential;

export async function startRegistration(options) {
  const pk = { ...options, challenge: fromB64u(options.challenge) };
  pk.user = { ...options.user, id: fromB64u(options.user.id) };
  if (options.excludeCredentials) {
    pk.excludeCredentials = options.excludeCredentials.map((c) => ({ ...c, id: fromB64u(c.id) }));
  }
  const cred = await navigator.credentials.create({ publicKey: pk });
  return {
    id: cred.id, rawId: toB64u(cred.rawId), type: cred.type,
    authenticatorAttachment: cred.authenticatorAttachment || null,
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
    response: {
      attestationObject: toB64u(cred.response.attestationObject),
      clientDataJSON: toB64u(cred.response.clientDataJSON),
      transports: cred.response.getTransports ? cred.response.getTransports() : [],
    },
  };
}

export async function startAuthentication(options) {
  const pk = { ...options, challenge: fromB64u(options.challenge) };
  if (options.allowCredentials) {
    pk.allowCredentials = options.allowCredentials.map((c) => ({ ...c, id: fromB64u(c.id) }));
  }
  const cred = await navigator.credentials.get({ publicKey: pk });
  return {
    id: cred.id, rawId: toB64u(cred.rawId), type: cred.type,
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
    response: {
      authenticatorData: toB64u(cred.response.authenticatorData),
      clientDataJSON: toB64u(cred.response.clientDataJSON),
      signature: toB64u(cred.response.signature),
      userHandle: cred.response.userHandle ? toB64u(cred.response.userHandle) : null,
    },
  };
}
